import { Component, OnInit } from '@angular/core';
import { FacilityDetail, DocumentDetail, ReturnDraftApplicationModel, ApplicationDetail, ReturnDraftDetail } from '../../models/ApplicationDetail';
import { UserDto } from '../../models/User';
import { FileUploader } from 'ng2-file-upload';
import { ApplicationInfo, ReturnApplication, FacilityView } from '../../models/ApplicationModel';
import { DocumentRef } from '../../models/DocumentRef';
import { ApplicationService } from '../../shared/services/application.service';
import { SettingsService } from '../../shared/services/settings.service';
import { AccountService } from '../../services/account.service';
import { FacilityService } from '../../shared/services/facility.service';
import { AlertService } from '../../shared/services/alert.service';
import { Router, ActivatedRoute } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { environment } from '../../../environments/environment';
import { ErisLoginService } from '../../services/sso/eris-login.service';
import { ErrorHandlerService } from '../../services/error-handler.service';
const URL =  environment.baseUrl + '/Attachment';

@Component({
  selector: 'app-return-application',
  templateUrl: './return-application.component.html',
  styleUrls: ['./return-application.component.css','../create/create-application.component.css']
})
export class ReturnApplicationComponent implements OnInit {

  public facilities: FacilityView[] = [];
  public tabList: Array < string > = ['returnDetail','fileAttachments'];
  public tab: string;
  public tabIndex: number;
  public buttonName: string;
  public user: UserDto;
  public uploader: FileUploader;
  public selectedFacilityId: number;
  public selectedFacilityCategoryName: string;
  public selectedFacility: FacilityView = null;
  public returnReasons: string;

  public documents: Array<DocumentDetail>;
  public documentRefs: Array<DocumentRef>;
  private allowedFileType = ['pdf'];
  private maxFileSize: number = 6 * 1024 * 1024; // 6 MB
  public draftMode: boolean;
  public returnDraft: ReturnDraftApplicationModel;
  public testObject: Object;
  private applicationId: number;
  private editMode = false;
  private applicationDetail: ApplicationDetail;
  public editDocuments: Array < DocumentDetail > ;
  public applicationInfo:ApplicationInfo;
  private draftApplicationId: number;
  public tempCOC = false;
  public returnDraftDetail : ReturnDraftDetail;

  constructor(private applicationService: ApplicationService, private settingsService: SettingsService,
    private accountService: AccountService, private facilityService: FacilityService, private alertService: AlertService,
    private router: Router, private route: ActivatedRoute, private spinner: NgxSpinnerService,
    private erisLoginService : ErisLoginService, private errorHandlerService: ErrorHandlerService) {
      this.applicationId = this.route.snapshot.params['id'];
      this.selectedFacilityId = parseInt(this.route.snapshot.queryParams.facilityId);
      const draftMode = this.route.snapshot.params['draft'];
      this.draftMode = (/true/i).test(draftMode);
      this.tempCOC = this.route.snapshot.params['temp'];
     }

  ngOnInit() {

  // initial setup
  this.uploader = new FileUploader({
    url: URL,
    allowedFileType: this.allowedFileType,
    maxFileSize: this.maxFileSize,
    headers: [{
      name: 'Authorization',
      value: 'Bearer ' + this.accountService.getTokenData()
    }]
  });

  if (this.applicationId) {
    this.editMode = true;
    this.getApplicationForEditing();
  }

    this.facilityService.getFacilitiesForCOCReturn(this.tempCOC).subscribe(
      res => {
        if (res) {
          this.facilities = this.facilities.concat(res);
          if (this.selectedFacilityId) {
            this.selectedFacility = this.facilities.filter(facility => facility.id === this.selectedFacilityId)[0];
            this.selectedFacilityCategoryName = this.selectedFacility.facilityCategoryName;
            this.facilitySelected();
          }
        } else {
          console.log('Error fetching facilities');
        }
      }, err => {
        console.log('Error fetching facilities ' + err);
        this.alertService.error('Error fetching facilities, ' + this.errorHandlerService.handleApiError(err));
      }
    );
    this.buttonName = 'Next';
    this.tabIndex = 0;
    this.tab = this.tabList[this.tabIndex];
    this.user = this.accountService.getUserData();
    this.documentRefs = [];
    this.documents = []; 
  }

  fetchDocumentsForReturn(){
    this.applicationService.getRequiredDocumentsForReturn(this.selectedFacility.facilityTypeID,
      this.selectedFacility.productTypeID, this.tempCOC ? 10 : 5, null).subscribe(
        documents=>{
          this.documentRefs = documents;  
    })
  }

  facilitySelected() {
    this.documents = [];
    this.selectedFacility = this.facilities.find(fac => fac.id === this.selectedFacilityId);
    if(!this.selectedFacility.productTypeID){
      this.selectedFacility.productTypeID = this.applicationDetail.productTypeID;
    }
    this.fetchDocumentsForReturn();
  }

  getApplicationForEditing() {
    if(this.draftMode){
       this.draftApplicationId = this.applicationId;
       this.applicationId = null;
         this.applicationService.getDraftApplication(this.draftApplicationId).subscribe(
           res => {
             this.returnDraftDetail = new ReturnDraftDetail(res);
             this.setReturnApplicationValues(this.returnDraftDetail,null);
           },
           err => {
             this.alertService.error('Unable to fetch draft application for editing. Please try again later.');
           }
         );
    }
    else{
      this.applicationService.getApplication(this.applicationId).subscribe(
        res => {     
          this.applicationDetail = new ApplicationDetail(res, null);
          this.setReturnApplicationValues(this.applicationDetail,(<any>res).applicationInfo);
        },
        err => {
          this.alertService.error('Unable to fetch application for editing. Please try again later.');
        }
      );
    }
  }

  setReturnApplicationValues(application,applicationInfo){
    this.applicationDetail = application;
    this.applicationInfo = applicationInfo;
    this.facilities = this.facilities.concat(application.facility)
    this.editDocuments = application.documents;
    this.selectedFacility = application.facility;
    this.selectedFacilityId = application.facility.id; 
    if(applicationInfo === null){
      this.returnReasons = application.summary;
    }
    else{
      this.returnReasons = this.applicationInfo.summary; 
    }  
    this.applicationId = application.id;
    this.facilitySelected();
  }

  tabClicked(tab) {
    this.tab = tab;
    this.tabIndex = this.tabList.indexOf(tab);
    this.setButtonName();
  }

  activeTab(tab) {
    return this.tab === tab;
  }

  nextClicked() {
    if(this.buttonName === 'Submit'){
      this.submitClicked();
    }
    else{
      this.tabIndex++;
      this.tab = this.tabList[this.tabIndex];
      this.setButtonName();
    }
  }

  buttonsShouldBeDisabled() {
    return !this.selectedFacility;
  }

  nextButtonsShouldBeDisabled() {
    return this.buttonsShouldBeDisabled() || !this.returnReasons;
  }

  setButtonName() {
    if (this.tab === 'fileAttachments') {
      this.buttonName = 'Submit';
    } else {
      this.buttonName = 'Next';
    }
  }

  saveReturn() {
    this.spinner.show();
    const returnApplicationDraft = new ReturnApplication(this.selectedFacility,this.documents,this.returnReasons);
    returnApplicationDraft.productTypeID = this.applicationDetail ? this.applicationDetail.productTypeID : this.selectedFacility.productTypeID;
    
    if(this.editMode){
      if(this.draftMode){        
        returnApplicationDraft.applicationID = this.returnDraftDetail.id;
      } else {
        returnApplicationDraft.applicationID = this.applicationId;
      }
      
    }

    this.returnDraft = new ReturnDraftApplicationModel(JSON.stringify(returnApplicationDraft), this.erisLoginService.getUserId());
    this.returnDraft.applicationCatagoryID = this.tempCOC ? 10 : 5;

    if(this.editMode){
      this.returnDraft['id'] = this.applicationDetail['draftID'];
      this.returnDraft['applicationNumber'] = this.applicationDetail['applicationNumber'];
    }
  
    this.applicationService.saveDraftApplication(this.returnDraft).subscribe(res => {
      this.spinner.hide();
      if (res) {
        this.alertService.success('Successfully saved replacement application');
        this.router.navigateByUrl('/applications/all');

      } else {
        this.alertService.error('Unable to save draft for application. Please try again later');
      }
    }, error => {
      this.spinner.hide();
    })
  }

  submitClicked() {
    this.spinner.show();
    if (this.editMode && (!this.draftMode || this.applicationId)) {
      let returnApplication: ReturnApplication = new ReturnApplication(this.selectedFacility,this.documents,this.returnReasons);
      returnApplication.applicationID = this.applicationDetail.id;
      // we will use the same api for editing return temp coc
      this.applicationService.editReturnApplication(returnApplication).subscribe(
        res => {
          this.spinner.hide();
          if (res) {
            this.alertService.success('Successfully submitted application');
            const _this = this;
            if (this.draftMode) {
              /**applicationId is the draft application id in this case */
              this.applicationService.deleteDraftApplication(this.draftApplicationId).subscribe(res=>{
                console.log('Draft version of the application has been removed');
              },err => {
                console.log('Unable to remove the draft version of the application');
                this.alertService.error('Unable to remove the draft version of the application');
              });
            }
            _this.router.navigateByUrl('/applications/list/' + this.applicationDetail.id);
          } else {
            this.alertService.error('Unable to submit application. Please try again later');
          }
        },
        err => {
          this.spinner.hide();
          this.alertService.error('Unable to submit application, ' + this.errorHandlerService.handleApiError(err));
        }
      );

    }else {
    const returnApplication: ReturnApplication = new ReturnApplication(this.selectedFacility,this.documents,this.returnReasons);

    this.applicationService.submitApplicationReturn(returnApplication, this.tempCOC).subscribe(
      res => {
        this.spinner.hide();
        if (res) {
          this.alertService.success('Successfully submitted application');
          const _this = this;
          if (this.draftMode) {
            /**applicationId is the draft application id in this case */
            this.applicationService.deleteDraftApplication(this.draftApplicationId).subscribe(res=>{
              console.log('Draft version of the application has been removed');
            },err => {
              console.log('Unable to remove the draft version of the application');
              this.alertService.error('Unable to remove the draft version of the application');
            });
          }
          _this.router.navigateByUrl('/applications/list/' + res.id);

        } else {
          this.alertService.error('Unable to submit application. Please try again later');
        }
      },
      err => {
        this.spinner.hide();
        this.alertService.error('Unable to submit application, '+ this.errorHandlerService.handleApiError(err));
      }
    );
    }
  }

   notFirstTab() {
    return !(this.tabIndex === 0);
  }

  backClicked() {
    this.tab = this.tabList[--this.tabIndex];
    this.setButtonName();
  }

  disableSave(){
    return (!this.selectedFacility || !this.returnReasons);
  }

}
